import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-lists-4',
  templateUrl: './4.component.html',
  styleUrls: ['./4.component.scss'],
})
export class VbList4Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
